import { render, staticRenderFns } from "./strategy-info.vue?vue&type=template&id=a9e71262&scoped=true"
import script from "./strategy-info.vue?vue&type=script&lang=js"
export * from "./strategy-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e71262",
  null
  
)

export default component.exports